<script setup>
import Sprite from '@/__core__/components/sprite/Sprite.vue'

defineProps({
  events: Array
})

const getSeparator = (minutes, index) => (minutes.length > 1 && index < minutes.length - 1 ? ',' : '')
</script>

<template>
  <div class="szw-flex szw-gap-1 szw-items-center">
    <div class="szw-flex szw-items-center szw-text-font-size-xs szw-leading-font-line-height-xs szw-gap-0.5" v-for="(event, index) in events" :key="index">
      <span v-for="(minute, index) of event.minutes" :key="`${event.type}-${minute}`">{{ minute }}{{ getSeparator(event.minutes, index) }}</span>

      <div class="szw-h-4 szw-w-4">
        <sprite :sprite-id="event.spriteId" height="16" width="16" />
      </div>
    </div>
  </div>
</template>
